import { CLEAR_GLOBAL_CONFIGS_EMIT } from '../../bin/constants';

// eslint-disable-next-line no-redeclare
/* global globalThis */

/**
 * Global configuration variables accessor.
 *
 * @param {string} name
 * @param {*} fallbackValue
 * @return {*}
 */
export function $global(name, fallbackValue = {}) {
  if (!(name in globalThis)) {
    if (process.env.NODE_ENV !== 'test') {
      console.warn('unable to access `globalThis["%s"]`', name); // >>>
    }
    return fallbackValue;
  }

  return globalThis[name];
}

/**
 * Create global config-dependent data cache.
 */
const cacheByName = {};

export function createCache(cacheName) {
  let _cache = {};

  const clearCache = () => _cache = {};

  if (cacheName in cacheByName) {
    cacheByName[cacheName]();
    process.off(CLEAR_GLOBAL_CONFIGS_EMIT, cacheByName[cacheName]);
  }

  cacheByName[cacheName] = clearCache;

  if (typeof process !== 'undefined' && typeof process.on === 'function') {
    process.on(CLEAR_GLOBAL_CONFIGS_EMIT, cacheByName[cacheName]);
  }

  /**
   * @template T
   * @param {string} key
   * @param {T} [initialValue={}]
   * @return {T}
   */
  return (key, initialValue = {}) => {
    return _cache[key] || (_cache[key] = initialValue);
  };
}
